module.exports = __webpack_public_path__ + "img/CO3_colored_secondary_version.d3817f8b.svg";